// extracted by mini-css-extract-plugin
module.exports = {"root":"goalForm_root__FO2Kf","rootResume":"goalForm_rootResume__1pq2V","content":"goalForm_content__pTr4x","table":"goalForm_table__G4Kfo","form":"goalForm_form__Bv8Ew"};